import React from "react";
import styled from "styled-components";

import SwitchCustom from "../switch_custom";
import { useTourGuiado } from "../../global/tourGuiadoContext";
import { useImpersonation } from "../../global/impersonation";
import { isTourGuiadoEnabled } from "../../config/featureFlags";

// Switch acima do logout para reativar o tour. D6:
// - on  -> hint_seen_at de cada step e zerado, PageHints voltam a aparecer.
//          Se o tour ja foi concluido (todos os 6 com completed_at), entra em
//          modo review (always_show_hints=true): tooltip abre TODA visita.
// - off -> tour fica em silencio (PageHints nao abrem).
// Auto-off: ao concluir o tour inicial, este switch e zerado automaticamente.
// Nao reabre o WelcomeModal nem o ProgressCard.

export default function TourSwitch({ expanded }) {
    const { isImpersonate } = useImpersonation();
    const { state, hydrated, enabledStepIds, setTourActive } = useTourGuiado();

    if (isImpersonate) return null;
    if (!hydrated) return null;
    if (!isTourGuiadoEnabled()) return null;
    // Sem nenhum step habilitado pelas permissoes (ex: admin so com refundPay)
    // o tour nunca apareceria, entao escondemos o switch para nao criar
    // expectativa de funcionalidade.
    if (enabledStepIds.length === 0) return null;

    const handleToggle = (event) => {
        setTourActive(event.target.checked);
    };

    return (
        <Holder>
            <SwitchCustom
                checked={!!state.tour_active}
                onChange={handleToggle}
                inputProps={{ "aria-label": "Reativar tour guiado" }}
            />
            <Label style={{ width: expanded ? 400 : 0 }}>
                Tour guiado
            </Label>
        </Holder>
    );
}

const Holder = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 16px;
`;

const Label = styled.span`
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    text-transform: uppercase;
    color: #181122;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: 0.4s;
`;
